interface Keys {
  upperCase: string;
  lowerCase: string;
  number: string;
}

const keys: Keys = {
  upperCase: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
  lowerCase: "abcdefghijklmnopqrstuvwxyz",
  number: "0123456789",
};

type KeyFunction = () => string;

const getKey: KeyFunction[] = [
  function upperCase(): string {
    return keys.upperCase[Math.floor(Math.random() * keys.upperCase.length)];
  },
  function lowerCase(): string {
    return keys.lowerCase[Math.floor(Math.random() * keys.lowerCase.length)];
  },
  function number(): string {
    return keys.number[Math.floor(Math.random() * keys.number.length)];
  },
];

const getRandomArbitrary = (min: number, max: number): number => {
  return Math.random() * (max - min) + min;
};

export const generatePassword = (): string => {
  const length = getRandomArbitrary(8, 16);
  console.log("Generate password ", length);
  let password = "";
  while (length > password.length) {
    let keyToAdd = getKey[Math.floor(Math.random() * getKey.length)];
    password += keyToAdd();
  }
  console.log("Generate password exit", password);

  return password;
};
